// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IQuestionResponse } from './IQuestionResponse';
import {
    IQuestionResponseFromJSON,
    IQuestionResponseFromJSONTyped,
    IQuestionResponseToJSON,
    IQuestionResponseToJSONTyped,
} from './IQuestionResponse';

/**
 * 
 * @export
 * @interface IQuestionsResponse
 */
export interface IQuestionsResponse {
    /**
     * 
     * @type {Array<IQuestionResponse>}
     * @memberof IQuestionsResponse
     */
    question?: Array<IQuestionResponse>;
}

/**
 * Check if a given object implements the IQuestionsResponse interface.
 */
export function instanceOfIQuestionsResponse(value: object): value is IQuestionsResponse {
    return true;
}

export function IQuestionsResponseFromJSON(json: any): IQuestionsResponse {
    return IQuestionsResponseFromJSONTyped(json, false);
}

export function IQuestionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IQuestionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'question': json['question'] == null ? undefined : ((json['question'] as Array<any>).map(IQuestionResponseFromJSON)),
    };
}

export function IQuestionsResponseToJSON(json: any): IQuestionsResponse {
    return IQuestionsResponseToJSONTyped(json, false);
}

export function IQuestionsResponseToJSONTyped(value?: IQuestionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question': value['question'] == null ? undefined : ((value['question'] as Array<any>).map(IQuestionResponseToJSON)),
    };
}

